import React, { useState } from 'react';
import ReactPlayer from 'react-player/youtube';
import { StarIcon, CheckCircleIcon, ClockIcon, DownloadIcon, ShoppingCartIcon } from 'lucide-react';
import { ExtraBonusModal } from './ExtraBonusModal';
export function ProductHero() {
  const [isExtraBonusModalOpen, setIsExtraBonusModalOpen] = useState(false);
  return <>
      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-6 sm:py-8 md:py-12 lg:py-16" data-id="element-398">
        <div className="grid lg:grid-cols-2 gap-6 sm:gap-8 lg:gap-12 xl:gap-16 items-center" data-id="element-399">
          {/* Product Image - Enhanced */}
          <div className="space-y-4 sm:space-y-6" data-id="element-400">
            <div className="relative" data-id="element-401">
              <div className="absolute -inset-2 sm:-inset-3 md:-inset-4 bg-gradient-to-r from-orange-200 to-orange-100 rounded-xl sm:rounded-2xl blur-xl sm:blur-2xl opacity-30" data-id="element-402"></div>
              <div className="relative" data-id="element-403">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/wUhxUHH5KYsbc5Kz1zJpha/PORTADA50_RECETAS_EBOOK.png" alt="50 Recetas de 15 Minutos" className="w-full max-w-md mx-auto rounded-xl sm:rounded-2xl shadow-xl sm:shadow-2xl" data-id="element-404" />
              </div>
              {/* Floating Badge */}
              <div className="absolute -top-3 -right-3 sm:-top-4 sm:-right-4 bg-orange-600 text-white px-3 py-1.5 sm:px-4 sm:py-2 rounded-full shadow-lg transform rotate-12" data-id="element-405">
                <div className="text-xs sm:text-sm font-bold" data-id="element-406">OFERTA</div>
                <div className="text-lg sm:text-xl font-bold" data-id="element-407">
                  NUEVO!! EDICION PREMIUM
                </div>
              </div>
            </div>
          </div>
          {/* Product Info - Redesigned */}
          <div className="space-y-4 sm:space-y-5 md:space-y-6" data-id="element-408">
            {/* Badge and Reviews */}
            <div className="flex items-center gap-2 sm:gap-3 flex-wrap" data-id="element-409">
              <div className="inline-flex items-center gap-1.5 bg-gradient-to-r from-orange-500 to-orange-600 text-white px-3 py-1.5 sm:px-4 sm:py-2 rounded-full text-xs sm:text-sm font-bold shadow-lg" data-id="element-410">
                <span data-id="element-411">✨</span>
                <span data-id="element-412">Best Seller</span>
              </div>
              <div className="flex items-center gap-1.5 bg-white px-3 py-1.5 sm:px-4 sm:py-2 rounded-full shadow-md" data-id="element-413">
                <div className="flex" data-id="element-414">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-3 h-3 sm:w-4 sm:h-4 fill-yellow-400 text-yellow-400" data-id="element-415" />)}
                </div>
                <span className="text-xs sm:text-sm font-semibold text-gray-700" data-id="element-416">
                  1,234 Familias
                </span>
              </div>
            </div>
            {/* Title */}
            <div data-id="element-417">
              <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-2 sm:mb-3 bg-gradient-to-r from-gray-900 to-gray-700 bg-clip-text text-transparent leading-tight" data-id="element-418">
                50 Recetas de 15 Minutos
              </h1>
              <h2 className="text-base sm:text-lg md:text-xl lg:text-2xl text-gray-600 font-light leading-snug" data-id="element-419">
                Para Mamá Ocupada que Quiere Cenas Rápidas Sin Sacrificar Sabor
              </h2>
            </div>
            {/* Pricing - Enhanced */}
            <div className="bg-gradient-to-br from-orange-50 to-orange-100 p-4 sm:p-6 rounded-xl sm:rounded-2xl border-2 border-orange-200 text-center" data-id="element-420">
              <div className="inline-flex items-center gap-2 bg-gradient-to-r from-orange-600 to-orange-500 text-white px-4 py-2 sm:px-6 sm:py-3 rounded-full mb-3 shadow-lg" data-id="element-421">
                <span className="text-xl sm:text-2xl" data-id="element-422">🚀</span>
                <span className="text-sm sm:text-base md:text-lg font-bold" data-id="element-423">
                  Oferta de Lanzamiento
                </span>
              </div>
              <p className="text-sm sm:text-base text-orange-700 font-semibold" data-id="element-424">
                Acceso especial por tiempo limitado
              </p>
            </div>
            {/* Description */}
            <p className="text-sm sm:text-base md:text-lg text-gray-700 leading-relaxed" data-id="element-425">
              50 recetas probadas y cronometradas. Cada una lista en exactamente
              15 minutos. Sin ingredientes raros, sin complicaciones. Solo
              comida rica que tu familia va a devorar.
            </p>
            {/* Feature Grid - Redesigned */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4" data-id="element-426">
              <div className="flex items-center gap-3 bg-white p-3 sm:p-4 rounded-xl shadow-md" data-id="element-427">
                <div className="flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 bg-orange-100 rounded-full flex items-center justify-center" data-id="element-428">
                  <CheckCircleIcon className="w-5 h-5 sm:w-6 sm:h-6 text-orange-600" data-id="element-429" />
                </div>
                <div className="text-sm sm:text-base font-semibold text-gray-800" data-id="element-430">
                  50 Recetas Probadas
                </div>
              </div>
              <div className="flex items-center gap-3 bg-white p-3 sm:p-4 rounded-xl shadow-md" data-id="element-431">
                <div className="flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 bg-orange-100 rounded-full flex items-center justify-center" data-id="element-432">
                  <ClockIcon className="w-5 h-5 sm:w-6 sm:h-6 text-orange-600" data-id="element-433" />
                </div>
                <div className="text-sm sm:text-base font-semibold text-gray-800" data-id="element-434">
                  15 Min Exactos
                </div>
              </div>
              <div className="flex items-center gap-3 bg-white p-3 sm:p-4 rounded-xl shadow-md" data-id="element-435">
                <div className="flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 bg-orange-100 rounded-full flex items-center justify-center" data-id="element-436">
                  <span className="text-xl sm:text-2xl" data-id="element-437">🥘</span>
                </div>
                <div className="text-sm sm:text-base font-semibold text-gray-800" data-id="element-438">
                  Ingredientes Simples
                </div>
              </div>
              <div className="flex items-center gap-3 bg-white p-3 sm:p-4 rounded-xl shadow-md" data-id="element-439">
                <div className="flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 bg-orange-100 rounded-full flex items-center justify-center" data-id="element-440">
                  <DownloadIcon className="w-5 h-5 sm:w-6 sm:h-6 text-orange-600" data-id="element-441" />
                </div>
                <div className="text-sm sm:text-base font-semibold text-gray-800" data-id="element-442">
                  Descarga Inmediata
                </div>
              </div>
            </div>
            {/* CTA Button - Enhanced */}
            <div className="space-y-3 sm:space-y-4" data-id="element-443">
              <div className="flex items-center justify-center gap-3 sm:gap-4 text-xs sm:text-sm text-gray-600 flex-wrap" data-id="element-444">
                <div className="flex items-center gap-1.5" data-id="element-445">
                  <CheckCircleIcon className="w-4 h-4 text-green-600 flex-shrink-0" data-id="element-446" />
                  <span data-id="element-447">Descarga Instantánea</span>
                </div>
                <div className="flex items-center gap-1.5" data-id="element-448">
                  <CheckCircleIcon className="w-4 h-4 text-green-600 flex-shrink-0" data-id="element-449" />
                  <span data-id="element-450">Garantía 30 Días</span>
                </div>
                <div className="flex items-center gap-1.5" data-id="element-451">
                  <CheckCircleIcon className="w-4 h-4 text-green-600 flex-shrink-0" data-id="element-452" />
                  <span data-id="element-453">Soporte LATAM</span>
                </div>
              </div>
              <p className="text-center text-xs sm:text-sm text-gray-500" data-id="element-454">
                Pago único • Acceso de por vida • Formato PDF descargable
              </p>
            </div>
            {/* What's Included - Redesigned */}
            <div className="bg-gradient-to-br from-orange-50 to-white p-4 sm:p-6 rounded-xl sm:rounded-2xl border-2 border-orange-200 shadow-lg" data-id="element-455">
              <div className="flex items-center gap-2 mb-3 sm:mb-4" data-id="element-456">
                <span className="text-xl sm:text-2xl" data-id="element-457">🎁</span>
                <h3 className="font-bold text-base sm:text-lg md:text-xl text-gray-900" data-id="element-458">
                  Lo Que Incluye
                </h3>
              </div>
              <ul className="space-y-2 sm:space-y-3" data-id="element-459">
                <li className="flex items-start gap-2.5 sm:gap-3" data-id="element-460">
                  <CheckCircleIcon className="w-5 h-5 text-orange-600 flex-shrink-0 mt-0.5" data-id="element-461" />
                  <span className="text-sm sm:text-base text-gray-700" data-id="element-462">
                    50 Recetas cronometradas en 15 minutos
                  </span>
                </li>
                <li className="flex items-start gap-2.5 sm:gap-3" data-id="element-463">
                  <CheckCircleIcon className="w-5 h-5 text-orange-600 flex-shrink-0 mt-0.5" data-id="element-464" />
                  <span className="text-sm sm:text-base text-gray-700" data-id="element-465">
                    Fotos paso a paso de cada receta
                  </span>
                </li>
                <li className="flex items-start gap-2.5 sm:gap-3" data-id="element-466">
                  <CheckCircleIcon className="w-5 h-5 text-orange-600 flex-shrink-0 mt-0.5" data-id="element-467" />
                  <span className="text-sm sm:text-base text-gray-700" data-id="element-468">
                    Lista de ingredientes imprimible
                  </span>
                </li>
                <li className="flex items-start gap-2.5 sm:gap-3" data-id="element-469">
                  <CheckCircleIcon className="w-5 h-5 text-orange-600 flex-shrink-0 mt-0.5" data-id="element-470" />
                  <span className="text-sm sm:text-base text-gray-700" data-id="element-471">
                    Tips de sustituciones por país
                  </span>
                </li>
                <li className="flex items-start gap-2.5 sm:gap-3" data-id="element-472">
                  <CheckCircleIcon className="w-5 h-5 text-orange-600 flex-shrink-0 mt-0.5" data-id="element-473" />
                  <span className="text-sm sm:text-base text-gray-700" data-id="element-474">
                    Actualizaciones gratuitas de por vida
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <ExtraBonusModal isOpen={isExtraBonusModalOpen} onClose={() => setIsExtraBonusModalOpen(false)} data-id="element-475" />
    </>;
}